import localeManager from '../../intl/LocalesManager';
import APPCONFIG from '../../constants/Config';
import * as types from '../../constants/ActionTypes';

const initialSettings = APPCONFIG.intl;
const intl = (state = initialSettings, action) => {
  let localeObject;
  switch (action.type) {
    // CHANGE_LOCALE
    case types.CHANGE_LOCALE:
      localeObject = localeManager.getLocale(action.locale);
      return {
        ...state,
        ...localeObject,
      };
    default:
      return state;
  }
};

export default intl;



// WEBPACK FOOTER //
// ./reducers/app/intl.js